export default "__VITE_ASSET__BkK0vRAY__"